import styled, { Color, Font, Spacing, BorderRadius, Breakpoint, Utils } from '@nfinite/react-hubstairs/styled'
import { transparentize } from 'polished'

import Icon from 'components/Commons/Icon'
import { LoadingDots } from '@nfinite/react-hubstairs/components'

export const Container = styled('div')`
  ${Font.generate({ weight: 'bold' })}
  color: ${Color.get('secondary', 'contrast')};
  height: 40px;
  line-height: 40px;
  background-color: ${({ theme }) => transparentize(0.5, theme.getColor('secondary'))};
  ${Spacing.generatePadding({ horizontal: 'm' })}
  ${BorderRadius.generate({ all: 'xxl' })}
  cursor: pointer;

  ${Breakpoint.greaterThanMobile()} {
    ${Utils.generateScaleRollhover({ fit: false })}
  }
`

export const BackContainer = styled('div')`
  display: inline-block;
  cursor: pointer;
  ${Utils.generateScaleRollhover({ fit: false })}

  & p {
    ${Font.generate({ size: 's' })}
  }
  & * {
    color: ${Color.get('gray', 'dark')};
    fill: ${Color.get('gray', 'dark')};
  }
`

export const BackIcon = styled(Icon)`
  width: 10px;
  height: 10px;
  margin-bottom: 2px;
  transform: rotate(180deg);
`

export const Loading = styled(LoadingDots)`
  max-width: 40px;
`
